import { FormattedMessage } from 'react-intl';

import { useImportContext } from '../import-context';
import { messages } from './messages';
import styles from './styles.module.less';
import { CurrencyLabel, DimensionUnitLabel, WeightUnitLabel } from './unit-label';
import { MeasurementTypeEnum } from './unit-of-measure-type';

/**
 * @typedef {import('../../../data/types/types').TemplateAttribute} TemplateAttribute
 */

/**
 * @param {TemplateAttribute} templateAttribute
 * @returns {React.ReactNode}
 */
const getMeasurementTypeContent = (templateAttribute) => {
  switch (templateAttribute.measurementType) {
    case MeasurementTypeEnum.None:
      return null;
    case MeasurementTypeEnum.Weight:
      return <WeightUnitLabel className={styles['template-attribute--unit']} />;
    case MeasurementTypeEnum.Dimension:
      return <DimensionUnitLabel className={styles['template-attribute--unit']} />;
    case MeasurementTypeEnum.Currency:
      return <CurrencyLabel className={styles['template-attribute--unit']} />;
    default:
      return null;
  }
};

/**
 * @param {TemplateAttribute} templateAttribute
 * @returns {React.ReactNode}
 */
const getAdditionalContent = (templateAttribute) => {
  if (templateAttribute.isRequired) {
    return (
      <div className={styles['template-attribute--required']}>
        <FormattedMessage {...messages.required} />
      </div>
    );
  }
  return null;
};

/**
 * @param {object} props
 * @param {TemplateAttribute} props.templateAttribute
 * @returns {React.JSX.Element}
 */
export const ShipstationField = ({ templateAttribute }) => {
  const { translateField } = useImportContext();

  return (
    <span className={styles['template-field']}>
      {translateField(templateAttribute.code)}
      {getMeasurementTypeContent(templateAttribute)}
      {getAdditionalContent(templateAttribute)}
    </span>
  );
};
